import React, { useCallback, useEffect, useState } from "react";
import { BarDatum, ResponsiveBar } from "@nivo/bar";
// import DataServices from '../../Services/DataServices';
// import ChartWebSocket from '../../WebSockets/ChartWebSocket';
import { Card, Grid2, Typography } from "@mui/material";
import { GetRouteSeverity } from "../../../../ApiServices/ApiRequests";
import {
  AssetOrLapsesChartData,
  RoutesSeverityChartData,
} from "../../../../Models/Models";
import {
  CtmLiveOverViewType,
  useCtmLiveOverView,
} from "../../../../ContextAPI/CtmLiveOverViewContext";
import { useTranslation } from "react-i18next";
import ChartWebSocket from "../../../../WebSockets/ChartWebSocket";
import Loading from "../../../../Controller/LoadingController/Loading";

export const RoutesChart = () => {
  const { ctmLiveOverViewState, dispatchCtmLiveOverView } =
    useCtmLiveOverView();
  const { t } = useTranslation();

  const handleInputChange = useCallback(
    (
      field: keyof CtmLiveOverViewType,
      value: string | boolean | number | null | RoutesSeverityChartData[]
    ) => {
      dispatchCtmLiveOverView({ type: "SET_FIELD", field, value });
    },
    [dispatchCtmLiveOverView]
  );

  const handleBulkChange = useCallback(
    (value: Partial<CtmLiveOverViewType>) => {
      dispatchCtmLiveOverView({ type: "BULK_UPDATE", value });
    },
    [dispatchCtmLiveOverView]
  );
  const [loading, setLoading] = useState<boolean>(false);
  const retrieveData = async (): Promise<void> => {
    try {
      setLoading(true);
      const result: RoutesSeverityChartData[] = await GetRouteSeverity();
      // Assuming the data is in result.data.data
      handleInputChange("RoutesSeverityChartData", result);
    } catch (e) {
      console.error("Error fetching  routes sevierity Count data:", e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    retrieveData();
  }, []);
  return (
    <Grid2 style={{ height: 150 }}>
      <Card style={{ width: "100%", height: "100%", padding: 10 }}>
        <Typography
          style={{ fontSize: `10px`, textAlign: `center`, margin: `10px` }}
        >
          {t("global.ROUTES")}
        </Typography>
        {loading ? (
          <Loading loading={loading} type={`dots`} backDrop={false} />
        ) : (
          <ResponsiveBar
            data={ctmLiveOverViewState.RoutesSeverityChartData}
            keys={["critical", "moderate", "clean"]}
            indexBy="name"
            margin={{ top: 0, right: 50, bottom: 50, left: 50 }}
            layout="vertical"
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            colors={["#e25d47", "#f4ca60", "#97e3d5"]}
            //padding={"0.5"}
            //innerPadding={"5px"}
            enableLabel={false}
            theme={{
              text: {
                color: "white",
                fontSize: `7px`,
              },

              tooltip: {
                container: {
                  color: "black",
                  background: "white",
                },
              },
            }}
            borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
            axisBottom={{
              tickSize: 2,
              tickPadding: 3,
              tickRotation: -25,
              legend: "",
              legendPosition: "middle",
              legendOffset: 10,
            }}
            labelSkipWidth={0}
            labelSkipHeight={2}
            labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
            animate={true}
            motionConfig="gentle"
            enableGridX={false}
            enableGridY={false}
          />
        )}
        <ChartWebSocket />
      </Card>
    </Grid2>
  );
};
